import { Input } from "design-react-kit";
import { useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function NewRange(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [data, setData] = useState({
    name: null,
    min: null,
    max: null,
    percent: null,
    fixedCost: null,
    role: null,
  });

  function toNumber(valore, type) {
    let value = valore.replace(/[^0-9.,]/g, "").replace(",", ".");
    const parts = value.split(".");

    if (parts.length > 2) {
      const integerPart = parts[0];
      const decimalPart = parts.slice(1).join("");
      value = integerPart + "." + decimalPart;
    } else {
      value = parts.join(".");
    }

    if (type === "euro") {
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        const integerPart = value.slice(0, decimalIndex);
        const decimalPart = value.slice(decimalIndex + 1, decimalIndex + 3);
        value = integerPart + "." + decimalPart;
      }
    }

    return value;
  }

  const newRangeValidation = () => {
    setValidation(true);
    let passedValidation = true;

    if (data.name == null) passedValidation = false;
    if (data.min == null) passedValidation = false;
    if (data.max == null) passedValidation = false;
    if (data.fixedCost == null) passedValidation = false;

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const insertRangeAPI = () => {
    Repo.postInsertRange(apiToken, JSON.stringify(data))
      .then((response) => {
        window.location.href = props.subfolder + "/fasce";
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkPercentage = (e) => {
    var perc = e.target.value;

    if (perc <= 100 && perc >= 0) {
      setData({
        ...data,
        percent: parseInt(perc),
      });
    }
  };

  return (
    <div>
      <h1>Nuova fascia ISEE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Inserisci una nuova fascia ISEE </p>
      </div>

      <div className="row  mt-3">
        <div className="col-lg-4">
          <Input
            id="first_name"
            required
            label="Nome*"
            type="text"
            name="first_name"
            {...(validation &&
              !data.name && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="min_value"
            required
            label="Valore Minimo*"
            type="number"
            name="min_value"
            min={0}
            {...(validation &&
              !data.min && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, min: e.target.value })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="max_value"
            required
            label="Valore Massimo*"
            type="number"
            name="max_value"
            min={0}
            {...(validation &&
              !data.max && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, max: e.target.value })}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-4">
          <label htmlFor="percentage">Percentuale</label>
          <div className="input-number input-number-percentage">
            <Input
              id="percentage"
              required
              type="number"
              name="percentage"
              value={data && data.percent && data.percent.toString()}
              onChange={(e) => checkPercentage(e)}
            />
          </div>
        </div>
        <div className="col-lg-4">
          <label htmlFor="fixed_cost">Quota Fissa*</label>
          <div className="input-number input-number-currency input-number-currency-custom">
            <Input
              id="fixed_cost"
              type="text"
              name="fixed_cost"
              className="pl-4"
              value={data.fixedCost ? data.fixedCost : ""}
              {...(validation &&
                !data.fixedCost && {
                  infoText: "Il campo non può essere vuoto!",
                  className: "text-danger error_div is-invalid",
                })}
              onChange={(e) =>
                setData({
                  ...data,
                  fixedCost: e.target.value
                    ? toNumber(e.target.value, "euro")
                    : data.fixedCost,
                })
              }
            />
          </div>
        </div>

        <div className="col-lg-4">
          <label htmlFor="percentage">Data entrata in vigore</label>
          <div className="input-string input-string">
            <Input
              id="dataVigore"
              type="date"
              name="dataVigore"
              value={data && data.dataVigore && data.dataVigore}
              onChange={(e) => setData({ ...data, dataVigore: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => newRangeValidation()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuova fascia ISEE"
        body="Confermi di voler inserire una nuova fascia ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => insertRangeAPI()}
      ></ModalComponent>
    </div>
  );
}

export default NewRange;
